import { TextPassage } from '@petsmart-ui/sparky';

import { ResponsivePicture } from '../../ResponsivePicture';
import './set-up-autoship.scss';

type SetUpAutoshipProductInfoProps = Readonly<{
    name: string;
    imageUrl: string;
}>;

export const SetUpAutoshipProductInfo = ({ name, imageUrl }: SetUpAutoshipProductInfoProps) => (
    <div className="set-up-autoship__product">
        <div className="set-up-autoship__product-image">
            <ResponsivePicture src={imageUrl} alt={name} size={{ width: 80, height: 80 }} />
        </div>
        <div className="set-up-autoship__product-name">
            <TextPassage>{name}</TextPassage>
        </div>
    </div>
);
